<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row justify="center" dense>
          <v-col cols="12" sm="6" md="6">
            <v-card class="box">
              <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                  <strong>Quiz Assessment Scheme Mapping</strong>
                </v-toolbar-title>
              </v-toolbar>
       <v-row justify="center" dense>
        <v-col sm="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"/>
          </v-col>
           <!-- <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Division</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="div_off" :items="div_off_list" item-text="division" item-value="division_off_id" label="Division" outlined persistent-hint hint="Please Select Division"/>
          </v-col> -->
             <v-col sm="2">
            <p><v-icon color="error">*</v-icon><b>Course </b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="course_off" :items="course_off_list" item-text="course" item-value="courseoffering_id" label="Course" outlined persistent-hint hint="Please Select Course"/>
          </v-col>
            <v-col cols="12" sm="2">
              <p></p>
              <v-btn class="mt-6 button" @click="getQuizData()" :loading="fetch_loader">Fetch</v-btn>        
            </v-col>
            </v-row>
              <span v-if="quiz_off_list != '' ">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table show-select v-if="quiz_off_list.length > 0" :headers="headers" :items="quiz_off_list" :search="search" class="elevation-1" v-model="selectedTasks" :single-select="singleSelect" item-key="id">
          </v-data-table>
        </v-card>
      </span>
         </v-card>
        </v-col>

         <v-col cols="12" sm="6" md="6" v-if="show_card">
          <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                <strong>Quiz Assessment Scheme Mapping</strong>
              </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
             <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"/>
          </v-col>
           <!-- <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Division</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="div_off" :items="div_off_list" item-text="division" item-value="division_off_id" label="Division" outlined persistent-hint hint="Please Select Division"/>
          </v-col> -->
             <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Course </b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="course_off" :items="course_off_list" item-text="course" item-value="courseoffering_id" label="Course" outlined persistent-hint hint="Please Select Course"/>
          </v-col>
           <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Semester </b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="semester" :items="sem_list" item-text="sem" item-value="id" label="semester" outlined persistent-hint hint="Please Select semester"/>
          </v-col>
            <v-col cols="12" sm="3">
              <p></p>
              <v-btn class="mt-6 button" @click="getAssessmentScheme()" :loading="fetch_loader">Fetch</v-btn>        
            </v-col>
            </v-row>
          </v-card>
         </v-col>
        </v-row>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      ay_list:[],ay:"",course_off_list:[],course_off:"",quiz_off_list:[],div_off:"",div_off_list:[],fetch_loader:false,show_card:false,sem_list:[],semester:"",search:"",
       selectedTasks: [], singleSelect: false,
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false, 
      title:"",
      description:"",
      headers:[
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      ],
  }),
   methods: {
    getAssessmentScheme(){
       const data = {
        ay: this.ay,
        course_off:this.course_off,
        semester:this.semester
      };
        this.overlay = true;
        axios
        .post("QuizScheduling/getAssessmentScheme",data)
        .then((res) => {
          if (res.data.flag == "YES") {
             this.overlay = false;
             this.showSnackbar("green", res.data.snackbar);
          } else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar);
             this.overlay = false;
          } 
          else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        }) 
        .finally(() => {
          this.overlay = false;
        });
    },
    getQuizData(){
      const data = {
        ay: this.ay,
        course_off:this.course_off,
      };
        this.overlay = true;
        axios
        .post("QuizScheduling/getQuizOfferings",data)
        .then((res) => {
          if (res.data.flag == "YES") {
             this.quiz_off_list=res.data.quiz_schedulings
             this.overlay = false;
             this.show_card=true
             this.showSnackbar("green", res.data.snackbar);
          } else if (res.data.flag == "No") {
             this.showSnackbar("#b71c1c", res.data.snackbar);
             this.overlay = false;
          } 
          else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        }) 
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad(){
         axios
        .post("QuizScheduling/quizAssessmentMapping")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.div_off_list=res.data.course_offering_instructor_details
            this.course_off_list=res.data.course_offering_instructor_details
            this.sem_list=res.data.sem_list
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>